import React from 'react'
import Helmet from 'react-helmet'

const HomePageMeta = () => {
  const siteUrl = process.env.RAZZLE_SITE_URL
  const organizationUrl = siteUrl + '/'
  const schemas = [{
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    name: process.env.RAZZLE_SCHEMA_SITE_NAME,
    legalName: process.env.RAZZLE_SCHEMA_ORG_LEGAL_NAME,
    url: organizationUrl,
    logo: {
      '@type': 'ImageObject',
      url: process.env.RAZZLE_SCHEMA_ORG_LOGO_URL,
      width: Number(process.env.RAZZLE_SCHEMA_ORG_LOGO_WIDTH),
      height: Number(process.env.RAZZLE_SCHEMA_ORG_LOGO_HEIGHT)
    },
    description: process.env.RAZZLE_SCHEMA_ORG_DESCRIPTION,
    sameAs: [
      process.env.RAZZLE_SITE_FACEBOOK,
      process.env.RAZZLE_SITE_YOUTUBE,
      process.env.RAZZLE_SITE_INSTAGRAM,
      process.env.RAZZLE_SCHEMA_ORG_LINKEDIN,
      process.env.RAZZLE_SITE_TWITTER,
      process.env.RAZZLE_SITE_PINTEREST
    ].filter(Boolean),
    address: {
      '@type': 'PostalAddress',
      streetAddress: process.env.RAZZLE_SCHEMA_ORG_STREET_ADDRESS,
      addressLocality: process.env.RAZZLE_SCHEMA_ORG_ADDRESS_LOCALITY,
      postalCode: process.env.RAZZLE_SCHEMA_ORG_POSTAL_CODE,
      addressCountry: process.env.RAZZLE_SCHEMA_ORG_ADDRESS_COUNTRY
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: process.env.RAZZLE_SCHEMA_ORG_TELEPHONE,
      contactType: process.env.RAZZLE_SCHEMA_ORG_CONTACT_TYPE
    }
  }, {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: siteUrl + '/search?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  }, {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: process.env.RAZZLE_SCHEMA_WEBPAGE_NAME,
    url: siteUrl.replace(/^https?:\/\//, '')
  }]

  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script key={index} type='application/ld+json'>
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  )
}

export default HomePageMeta
